import React from 'react';

import Page from '../../shared/components/Page';

import { AppCreateContainer } from '../components/AppCreate';

const AppCreate = (props) => {
    return (
        <Page>
            <Page.MainArea>
                <AppCreateContainer {...props} />
            </Page.MainArea>
        </Page>
    )
}

export default AppCreate;


// WEBPACK FOOTER //
// ./src/apps/pages/AppCreate.js